import type { z } from "zod";
import type { AxiosError, AxiosRequestHeaders } from "axios";
import { ApiError, ParseError } from "@/api/errors";

export function parseWithSchema<T, I = unknown>(schema: z.ZodType<T, z.ZodTypeDef, I>, data: unknown): T {
  const result = schema.safeParse(data);
  if (!result.success) {
    throw new ParseError("Failed to parse API response", result.error.flatten());
  }
  return result.data;
}

export function toApiError(error: unknown): ApiError {
  if (error instanceof ApiError) {
    return error;
  }

  const maybeAxios = error as AxiosError;
  const status = maybeAxios?.response?.status;
  const headers = maybeAxios?.config?.headers as AxiosRequestHeaders | undefined;
  const correlationId = headers?.["X-Correlation-Id"];
  const data = maybeAxios?.response?.data as { detail?: string } | undefined;
  const message =
    data?.detail ??
    maybeAxios?.message ??
    "Unexpected API error occurred";

  return new ApiError(
    typeof message === "string" ? message : "Unexpected API error occurred",
    status,
    typeof correlationId === "string" ? correlationId : undefined
  );
}

